import React, { useState } from 'react';
import { FaStore, FaBars, FaTimes, FaHome, FaInfoCircle, FaPhoneAlt, FaSignInAlt, FaUndo, FaMapMarkerAlt } from 'react-icons/fa'; // Added new icons
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('/'); // Default active link is Home

  // Function to handle link clicks, close the menu and set the active link
  const handleLinkClick = (link) => {
    setActiveLink(link); // Set the active link
    setMenuOpen(false); // Close the menu
  };

  return (
    <nav className="navbar">
      {/* Burger Menu Icon */}
      <div className="burger-menu" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Logo Container */}
      <div className="logo-container">
        <h1 className="Shop">Tellaman</h1>
      </div>

      {/* Navigation Links */}
      <div className={`links ${menuOpen ? 'active' : ''}`}>
        <Link
          to="/shop"
          onClick={() => handleLinkClick('/shop')} // Handle click for Home
          className={activeLink === '/shop' ? 'active' : ''}
        >
          <FaHome /> Home
        </Link>
        <Link
          to="/about"
          onClick={() => handleLinkClick('/about')} // Handle click for About Us
          className={activeLink === '/about' ? 'active' : ''}
        >
          <FaInfoCircle /> About Us
        </Link>
        <Link
          to="/contact"
          onClick={() => handleLinkClick('/contact')} // Handle click for Contact Us
          className={activeLink === '/contact' ? 'active' : ''}
        >
          <FaPhoneAlt /> Contact Us
        </Link>

        {/* New Links for Log In, Return, and Track Order - Will show only when burger menu is open */}
        {menuOpen && (
          <div className="additional-links">
            <Link
              to="/login"
              onClick={() => handleLinkClick('/login')} // Handle click for Log In
              className={activeLink === '/login' ? 'active' : ''}
            >
              <FaSignInAlt /> Log In
            </Link>
            <Link
              to="/return"
              onClick={() => handleLinkClick('/return')} // Handle click for Return
              className={activeLink === '/return' ? 'active' : ''}
            >
              <FaUndo /> Return
            </Link>
            <Link
              to="/track-order"
              onClick={() => handleLinkClick('/track-order')} // Handle click for Track Order
              className={activeLink === '/track-order' ? 'active' : ''}
            >
              <FaMapMarkerAlt /> Track Order
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
